import { useCallback } from 'react';
import { authenticate as rawAuthenticate, AuthParams } from '../../lib/authenticate';
import { useTwoFactorAuthenticationFeatureFlag } from '../useTwoFactorAuthenticationFeatureFlag';

export const useAuthenticate = () => {
  const { enabled: twoFactorAuthLoginEnabled } = useTwoFactorAuthenticationFeatureFlag();

  const authenticate = useCallback(
    (authParams: Omit<AuthParams, 'version'>) =>
      rawAuthenticate({ ...authParams, twoFactorAuthLoginEnabled }),
    [twoFactorAuthLoginEnabled]
  );

  return { authenticate };
};
